<template>
    <ContainerComponent>
        <PagePreview :pageId="$route.params.pageId"/>
    </ContainerComponent>
</template>
<script>
import PagePreview from '@/components/complex.component/PagePreview.vue';
import ContainerComponent from '@/components/ContainerComponent';

export default {
    components: {
        ContainerComponent,
        PagePreview
    }
}
</script>